export const API_ROUTE = "https://sepantaapi.paratechco.com/api/"